import React, { Component, PropTypes } from 'react'
import { Router } from 'react-router'
import { Provider } from 'react-redux'
import { applyRouterMiddleware } from 'react-router'
import { useScroll } from 'react-router-scroll'
import '../styles/style.scss'

class AppContainer extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    routes: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired
  }

  render () {
    const { history, routes, store } = this.props

    return (
      <Provider store={store}>
        <Router history={history} children={routes}
                render={applyRouterMiddleware(useScroll())}/>
      </Provider>
    )
  }
}

export default AppContainer



/** WEBPACK FOOTER **
 ** ./src/containers/AppContainer.js
 **/